import classNames from 'classnames'
import { bool } from 'prop-types'

import Button from 'views/components/atoms/Button'

import './ButtonAsLink.scss'

const ButtonAsLink = props => {
  const {
    children,
    neutral,
    className,
    inheritColor,
    left,
    fullWidth,
    flex,
    underlined,
    bold,
    ...rest
  } = props

  const buttonClasses = classNames(className, 'm-ButtonAsLink', {
    'm-ButtonAsLink--neutral': neutral,
    'm-ButtonAsLink--inherit': inheritColor,
    'm-ButtonAsLink--left': left,
    'm-ButtonAsLink--flex': flex,
    'm-ButtonAsLink--full-width': fullWidth,
    'm-ButtonAsLink--underlined': underlined,
    'm-ButtonAsLink--bold ': bold,
  })

  return (
    <Button {...rest} className={buttonClasses}>
      {children}
    </Button>
  )
}

ButtonAsLink.propTypes = {
  ...Button.propTypes,
  neutral: bool,
  underlineOnHover: bool,
  left: bool,
  flex: bool,
  fullWidth: bool,
  underlined: bool,
  bold: bool,
}

ButtonAsLink.defaultProps = {
  ...Button.defaultProps,
  neutral: false,
  inheritColor: false,
  left: false,
  flex: false,
  fullWidth: false,
  underlined: false,
  bold: false,
}

export default ButtonAsLink
